'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var json2mq = _interopDefault(require('json2mq'));

var index = {
  name: 'media',
  props: {
    query: {
      type: [Object, String],
      required: true
    },
    visibleByDefault: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      matches: this.visibleByDefault
    }
  },
  methods: {
    updateMatches: function updateMatches() {
      this.matches = this.mediaQueryList.matches;
    }
  },
  mounted: function mounted() {
    var ref = this;
    var query = ref.query;
    var matches = ref.matches;
    if (typeof window === 'undefined') {
      return matches
    }
    var mediaQuery = json2mq(query);
    this.mediaQueryList = window.matchMedia(mediaQuery);
    this.updateMatches();
    this.mediaQueryList.addListener(this.updateMatches);
  },
  render: function render() {
    if (this.matches) {
      return this.$slots.default[0]
    }
    return
  },
  beforeDestroy: function beforeDestroy() {
    if (this.mediaQueryList) {
      this.mediaQueryList.removeListener(this.updateMatches);
    }
  }
};

module.exports = index;



//////////////////
// WEBPACK FOOTER
// ./~/vue-media/dist/vue-media.common.js
// module id = 189
// module chunks = 6